import React, { Suspense } from 'react';

const withSuspense = Component => props => (
  <Suspense fallback={<div />}>
    <Component {...props} />
  </Suspense>
);

export default withSuspense;
